// Library Methods
import { useMemo } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

// Components
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Loader from "../../loaders/Loader/Loader";

// Styles
import { PageContainerWrapper } from "src/styles/mui/muiStylesHelper";

type ProtectedRouteType = {
  component: React.ComponentType<object>;
};

// Prevents the page from reloading when the theme is toggled from the navbar
const RedirectingLoader = () => {
  const theme = useTheme();

  return (
    <Box sx={{ ...PageContainerWrapper(theme), padding: 0 }}>
      <Loader />
    </Box>
  );
};

const ProtectedRoute = ({ component }: ProtectedRouteType) => {
  const Component = useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => <RedirectingLoader />,
      }),
    [component]
  );

  return <Component />;
};

export default ProtectedRoute;
